import { render, staticRenderFns } from "./FolderNameModal.vue?vue&type=template&id=241d90a8&scoped=true"
import script from "./FolderNameModal.vue?vue&type=script&lang=js"
export * from "./FolderNameModal.vue?vue&type=script&lang=js"
import style0 from "./FolderNameModal.vue?vue&type=style&index=0&id=241d90a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241d90a8",
  null
  
)

export default component.exports